import { render } from "./ModeratorChat.vue?vue&type=template&id=f6b0f03c&scoped=true&ts=true"
import script from "./ModeratorChat.vue?vue&type=script&lang=ts"
export * from "./ModeratorChat.vue?vue&type=script&lang=ts"

import "./ModeratorChat.vue?vue&type=style&index=0&id=f6b0f03c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b0f03c"]])

export default __exports__